import { useState } from "react";

// Modal para exibir PDF
const ModalPDF = ({ show, onClose, pdfUrl, titulo }) => {
  if (!show) return null;

  return (
    <div
      className="modal show d-block"
      style={{ backgroundColor: "rgba(0,0,0,0.5)" }}
    >
      <div className="modal-dialog modal-xl">
        <div className="modal-content">
          <div className="modal-header">
            <h5 className="modal-title">📊 {titulo}</h5>
            <button
              type="button"
              className="btn-close"
              onClick={onClose}
            ></button>
          </div>
          <div className="modal-body p-0" style={{ height: "80vh" }}>
            {pdfUrl ? (
              <iframe
                src={pdfUrl}
                width="100%"
                height="100%"
                style={{ border: "none" }}
                title="Relatório PDF"
              />
            ) : (
              <div className="d-flex justify-content-center align-items-center h-100">
                <div className="text-center">
                  <div className="spinner-border text-primary mb-3"></div>
                  <p>Carregando relatório...</p>
                </div>
              </div>
            )}
          </div>
        </div>
      </div>
    </div>
  );
};

const BotaoRelatorio = ({
  tipo,
  texto,
  icone = "📊",
  parametros,
  formato = "pdf", // 🆕 Nova prop para formato (pdf ou excel)
  onStartGeneration,
  onFinishGeneration,
  abrirEmModal = false,
  className = "btn btn-outline-secondary btn-sm me-2",
}) => {
  const [generating, setGenerating] = useState(false);
  const [carregando, setCarregando] = useState(false);
  const [mensagem, setMensagem] = useState("");

  // Estados para o modal PDF
  const [showModal, setShowModal] = useState(false);
  const [pdfUrl, setPdfUrl] = useState(null);

  // 🆕 Configurações de formato
  const FORMATOS_CONFIG = {
    pdf: {
      extensao: ".pdf",
      contentType: "application/pdf",
      icone: "📄",
      descricao: "PDF",
      permiteModal: true,
    },
    excel: {
      extensao: ".xlsx",
      contentType:
        "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
      icone: "📊",
      descricao: "Excel",
      permiteModal: false, // Excel não pode ser visualizado em iframe
    },
    xlsx: {
      extensao: ".xlsx",
      contentType:
        "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
      icone: "📊",
      descricao: "Excel",
      permiteModal: false,
    },
  };

  // Função para obter token e headers
  const obterTokenEHeaders = () => {
    const token = localStorage.getItem("authToken");
    if (!token) {
      return { success: false, message: "Token não encontrado" };
    }

    const headers = {
      Authorization: `Bearer ${token}`,
      "Content-Type": "application/json",
    };

    return { success: true, headers, token };
  };

  const handleClick = async () => {
    // VERIFICAR SE DEVE USAR MODAL DE LOADING OU FEEDBACK LOCAL
    const useModal = onStartGeneration && onFinishGeneration;

    // 🆕 Obter configuração do formato
    const formatoNormalizado = formato.toLowerCase();
    const formatoConfig =
      FORMATOS_CONFIG[formatoNormalizado] || FORMATOS_CONFIG.pdf;

    if (useModal) {
      setGenerating(true);
      onStartGeneration(tipo, texto);
    } else {
      setCarregando(true);
      setMensagem("");
    }

    try {
      const API_URL = process.env.REACT_APP_API_URL || "http://localhost:3001";

      // Verificar token
      const authResult = obterTokenEHeaders();
      if (!authResult.success) {
        throw new Error(authResult.message);
      }

      console.log("🚀 Gerando relatório:", {
        tipo,
        parametros,
        formato: formatoNormalizado,
      });

      const response = await fetch(`${API_URL}/reports/gerar`, {
        method: "POST",
        headers: authResult.headers,
        body: JSON.stringify({
          tipo: tipo,
          parametros: parametros,
          formato: formatoNormalizado, // 🆕 Enviar formato para backend
        }),
      });

      console.log("📡 Response status:", response.status);

      if (response.status === 401) {
        throw new Error("Token expirado ou inválido. Faça login novamente.");
      }

      if (response.ok) {
        const blob = await response.blob();

        // 🆕 Tentar obter o nome do arquivo do header
        const contentDisposition = response.headers.get("Content-Disposition");
        let fileName = `${tipo}_${new Date().getTime()}${
          formatoConfig.extensao
        }`;

        if (contentDisposition) {
          const fileNameMatch =
            contentDisposition.match(/filename="?([^"]+)"?/);
          if (fileNameMatch) {
            fileName = fileNameMatch[1];
          }
        }

        // 🆕 VERIFICAR SE O FORMATO PERMITE MODAL
        const podeAbrirEmModal = abrirEmModal && formatoConfig.permiteModal;

        if (podeAbrirEmModal) {
          // ✅ ABRIR EM MODAL (apenas PDF)
          const url = window.URL.createObjectURL(blob);
          setPdfUrl(url);
          setShowModal(true);

          const successMessage = `✅ Relatório ${texto} (${formatoConfig.descricao}) gerado e aberto!`;

          if (useModal) {
            onFinishGeneration(true, successMessage);
          } else {
            setMensagem(successMessage);
            setTimeout(() => setMensagem(""), 3000);
          }
        } else {
          // ✅ DOWNLOAD AUTOMÁTICO
          const url = window.URL.createObjectURL(blob);
          const link = document.createElement("a");
          link.href = url;
          link.download = fileName;
          document.body.appendChild(link);
          link.click();
          document.body.removeChild(link);
          window.URL.revokeObjectURL(url);

          // 🆕 Mensagem personalizada baseada no formato
          let successMessage = `✅ Relatório ${texto} (${formatoConfig.descricao}) gerado e baixado com sucesso!`;

          if (abrirEmModal && !formatoConfig.permiteModal) {
            successMessage = `✅ Relatório ${texto} (${formatoConfig.descricao}) baixado! (${formatoConfig.descricao} não pode ser visualizado no navegador)`;
          }

          if (useModal) {
            onFinishGeneration(true, successMessage);
          } else {
            setMensagem(successMessage);
            setTimeout(() => setMensagem(""), 3000);
          }
        }

        console.log(
          `✅ Relatório ${formatoConfig.descricao} gerado com sucesso!`
        );
      } else {
        let errorMessage = "Erro ao gerar relatório";
        try {
          const errorData = await response.json();
          errorMessage = errorData.message || errorData.error || errorMessage;
        } catch {
          errorMessage = `HTTP ${response.status}: ${response.statusText}`;
        }
        throw new Error(errorMessage);
      }
    } catch (error) {
      console.error("❌ Erro ao gerar relatório:", error);

      const errorMessage = `Erro ao gerar relatório: ${error.message}`;

      if (useModal) {
        onFinishGeneration(false, errorMessage);
      } else {
        setMensagem(`❌ ${errorMessage}`);
        setTimeout(() => setMensagem(""), 5000);
      }

      // SE FOR ERRO DE AUTENTICAÇÃO, REDIRECIONAR PARA LOGIN
      if (error.message.includes("Token") || error.message.includes("login")) {
        setTimeout(() => {
          window.location.href = `${process.env.PUBLIC_URL}/login`;
        }, 2000);
      }
    } finally {
      if (useModal) {
        setGenerating(false);
      } else {
        setCarregando(false);
      }
    }
  };

  // Função para fechar modal e limpar URL
  const handleCloseModal = () => {
    setShowModal(false);
    if (pdfUrl) {
      window.URL.revokeObjectURL(pdfUrl);
      setPdfUrl(null);
    }
  };

  // DETERMINAR ESTADO DE LOADING BASEADO NO MODO
  const isLoading = onStartGeneration ? generating : carregando;

  // 🆕 Obter ícone do formato se não foi fornecido customizado
  const formatoNormalizado = formato.toLowerCase();
  const formatoConfig =
    FORMATOS_CONFIG[formatoNormalizado] || FORMATOS_CONFIG.pdf;
  const iconeExibir = icone === "📊" ? formatoConfig.icone : icone;

  return (
    <>
      <div className="d-inline-block">
        <button
          className={className}
          onClick={handleClick}
          disabled={isLoading}
          title={`Gerar relatório ${texto} (${formatoConfig.descricao})`}
        >
          {isLoading ? (
            <>
              <span
                className="spinner-border spinner-border-sm me-1"
                style={{ width: "0.8rem", height: "0.8rem" }}
              ></span>
              Gerando...
            </>
          ) : (
            <>
              {iconeExibir} {texto}
            </>
          )}
        </button>

        {/* MOSTRAR MENSAGEM APENAS SE NÃO ESTIVER USANDO MODAL */}
        {mensagem && !onStartGeneration && (
          <div
            className={`small mt-1 ${
              mensagem.includes("✅") ? "text-success" : "text-danger"
            }`}
          >
            {mensagem}
          </div>
        )}
      </div>

      {/* MODAL PARA EXIBIR PDF */}
      <ModalPDF
        show={showModal}
        onClose={handleCloseModal}
        pdfUrl={pdfUrl}
        titulo={texto}
      />
    </>
  );
};

export default BotaoRelatorio;
